import styled from 'styled-components'
import { CustomButton } from '../../styles/global'

export const Subtitle = styled.h2`
  font-size: 1rem;
  line-height: 120%;
  font-weight: 600;
  color: #222222;
  margin: 0 0 4px 0;
`
export const Text = styled.p`
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: .875rem;
  line-height: 145%;
  margin: 0 0 1rem 0;
  color: #555555;
`

export const ReviewTitle = styled.span`
  font-size: 24px;
  font-weight: bold;
  text-align: center
`

export const HorizontalLine = styled.hr`
  width: 100%;
  border-bottom: 1px solid #999999;
`

export const RatingAverage = styled.div`
  display: flex;
  flex-direction: row;

  .react-simple-star-rating span svg {
    margin: 0 4px;
  }
`

export const PreciseRatingAverage = styled.div`
  h2 {
    font-size: 48px;
    color: #222222;
  }
  text-align: center;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const EachRating = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const TotalRatings = styled.div`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
  text-align: center;
  color: #555555;
  margin-top: 18px;
`

export const NoRatingWarning = styled.div`
  text-align: center;
  margin-bottom: 16px;
`

export const NavButton = styled(CustomButton)`
`
